export enum AppEnvironments {
  Development = "dev",
  PreProduction = "preprod",
  PreProductionFedRAMP = "preprod-fedramp",
  Production = "prod",
  ProductionUs = "prod-us",
  ProductionFedRAMP = "prod-fedramp",
}
